import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { toBase64 } from '@aws-sdk/util-base64-node';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'file-preview-setup',
  templateUrl: './file-preview-setup.component.html',
  styleUrls: ['./file-preview-setup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilePreviewSetupComponent implements OnInit {
  @Input() file;
  @Input() currentuserId;
  @Input() IconName;
  loadingUrl = 'assets/images/loading-image-icon.gif';
  filsrData;
  isActive = false;
  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.filsrData = this.file.link;
  }
  StartPreviewImage() {
    this.getUrl(this.file);
  }

  async getUrl(file) {
    this.displayImageWithUrl(null, file);
  }
  generateDataKeyPair(security_key: any): unknown {
    throw new Error('Method not implemented.');
  }
  displayImageWithUrl(res, file) {
    if (this.file.file_name.includes('.pdf')) {
      this.filsrData = file.link;
      this.cd.detectChanges();
      return;
    } else {
      // this.filsrData = decrypted_file;
      var xhr = new XMLHttpRequest();

      xhr.open('GET', file.link, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.filsrData = event.target.result;
          this.cd.detectChanges();
        };
        var file1 = xhr.response;

        reader.readAsDataURL(file1);
      };
      xhr.send();
    }
  }

  showPDFImageProcess(data, fileData, file) {
    let res = data;
    let decrypted_file;
    let decryption_key;

    // if (res.data.premium_encrypted == 'encrypted' || res.data.premium_encrypted == 'pending_decryption') {
    //   //decrypt file using user's security key
    //   decryption_key = this.cryptoService.decryptDataKey(res.data.key, this.security_key, this.sk);
    //   decrypted_file = this.cryptoService.decryptFile(fileData, decryption_key);
    // } else {
    //   //get key to decrypt file
    //   decryption_key = this.cryptoService.decryptWithPassword(res.data.key, environment.encryption_mask_id);
    //   decrypted_file = this.cryptoService.decryptFile(fileData, decryption_key);
    // }
    if (this.checkIfImage(file.name)) {
      this.filsrData = `data:image/${file.name.split('.').pop()};base64,${toBase64(decrypted_file)}`;
    } else {
      var fileD = new Blob([decrypted_file], { type: 'application/pdf' });

      var fileURL = URL.createObjectURL(fileD);

      const reader = new FileReader();
      const binaryString = reader.readAsDataURL(fileD);
      reader.onload = (event: any) => {
        //Here you can do whatever you want with the base64 String
        this.filsrData = event.target.result;

        this.cd.markForCheck();
      };

      const blob = new Blob([decrypted_file], { type: 'application/octet-stream' });
    }
  }

  checkIfImage(fileName) {
    if (fileName != undefined) {
      const fileNameFormated = fileName.toLowerCase();
      if (
        fileNameFormated.includes('jpeg') ||
        fileNameFormated.includes('png') ||
        fileNameFormated.includes('jpg') ||
        fileNameFormated.includes('giff')
      ) {
        return true;
      }
      return false;
    }
    return false;
  }
}
